<template>
  <div class="content">
    <revision-form :datas="dataall"></revision-form>
    <sklad :datas="dataall"></sklad>
    <paytype :datas="dataall"></paytype>
    <product :datas="dataall"></product>
    <unit></unit>
    <model></model>
    <brand></brand>
    <colour></colour>
    <country></country>
    <firma></firma>
    <b-modal id="modal-close" centered>
      <h4>
        {{$t('Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?')}}
      </h4>

      <template #modal-footer="{ ok, cancel, hide }">
        <button type="button" class="btn btn-success" style="margin-bottom: 16px;"
          @click="$root.$refs.revision.Savedokument()">{{$t('Да')}}</button>
        <button type="button" class="btn btn-danger" @click='Home()'>{{$t('Нет')}}</button>
        <button type="button" class="btn btn-primary" @click="cancel()">{{$t('Отмена')}}</button>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import RevisionForm from "./Jamlash.vue"
import {
  Firma,
  Sklad,
  Paytype,
  Product,
  Unit,
  Model,
  Brand,
  Colour,
  Country
} from "@/pages";
export default {
  components: {
    Firma,
    RevisionForm,
    Sklad,
    Paytype,
    Product,
    Unit,
    Model,
    Brand,
    Colour,
    Country
  },
  watch: {
    dataall: {
      deep: true,
      handler(val, oldVal) {
        this.$store.state.saved += 1;
      }
    }
  },
  methods:{
    Home() {
        this.$store.state.saved = null;
        this.$bvModal.hide('modal-close');
        this.$router.push({ name: "Ревизия" });
      }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.saved == null) {
      this.$store.state.saved = null;
      next();
    } else {
      this.$bvModal.show("modal-close");
    }
  },
  data() {
    return {
      errors: "",
      dataall: {
        sklad_id: parseInt(localStorage.getItem("sklad_id")),
        created_at: new Date()
          .valueOf()
          .toString()
          .slice(0, 10),
        updated_at: new Date()
          .valueOf()
          .toString()
          .slice(0, 10),
        kontragent_id: 0,
        count_all: 0,
        user_id: parseInt(localStorage.getItem("user_id")),
        comment: "",
        summa: 0,
        total_real_count: 0,
        total_difference: 0,
        real: true,
        doc_type:'real',
        doc:[],
        revision_table: []
      }
    };
  }
};
</script>
